import React, { useContext } from "react"
import { ParentTabBackground } from "../../../ports/primary/ui/screens/parent/ParentTabBackground"
import { ParentLayoutContext } from "./ParentLayoutContext"
import { ParentTabHeader } from "./ParentTabHeader"

/**
 * Lightweight wrapper component for parent tab screens
 * Only renders header and modals - all state managed in ParentMainLayout
 *
 * `glow` : cet onglet est l'accueil, qui porte la lueur — voir `ParentTabBackground`.
 */
const ParentTabScreenWrapper = (props) => {
    const { children, glow, ...restProps } = props

    // Get shared state from context (managed in ParentMainLayout)
    const parentContext = useContext(ParentLayoutContext)

    const {
        familyAccounts = [],
        selectedUser,
        handleUserSelection,
        handleExitToChild,
        switchingAccountId,
        isLoggingOut,
        startLogout,
        user,
        openSupportChat,
    } = parentContext

    return (
        <ParentTabBackground glow={glow}>
            <ParentTabHeader
                familyAccounts={familyAccounts}
                selectedUser={selectedUser}
                onUserSelection={handleUserSelection}
                onExitToChild={handleExitToChild}
                user={user}
                switchingAccountId={switchingAccountId}
                isLoggingOut={isLoggingOut}
                startLogout={startLogout}
                openSupportChat={openSupportChat}
            />

            {/* Render children with necessary props */}
            {React.cloneElement(children, {
                ...restProps,
                selectedUser,
                familyAccounts,
                startLogout,
                handleUserSelection,
            })}
        </ParentTabBackground>
    )
}

export default ParentTabScreenWrapper
